import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 75px; 
    }`
  }
`

const FilterSelectIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="110" height="31" viewBox="0 0 110 31" isFromWidgetChoice={isFromWidgetChoice}>
      <g id="filter_select" transform="translate(1355 -9391)">
        <path className="fillHoverSVG" id="Tracé_4211" data-name="Tracé 4211" d="M2,0,4,3H0Z" transform="translate(-1254 9409) rotate(180)" fill="#787878" />
        <g className="strokeHoverSVG" id="Rectangle_2737" data-name="Rectangle 2737" transform="translate(-1355 9391)" fill="none" stroke="#787878" strokeWidth="2">
          <rect width="110" height="31" rx="5" stroke="none" />
          <rect className="strokeHoverSVG" x="1" y="1" width="108" height="29" rx="4" fill="none" />
        </g>
      </g>
    </SVG>
  </IconContainer>
)

export default FilterSelectIcon